import { AddressDecodeYandexDTO } from '@common/contracts/server/modules/address/presentation/api/dto';

import type { FetcherAxiosInstance } from '../fetcher';

export const createAddressApi = (Fetcher: FetcherAxiosInstance) => ({
  addressDecode(params: { address: string }): Promise<AddressDecodeYandexDTO[]> {
    return Fetcher('/address/decode', { params });
  },
});
